<template>
  <div v-if="goalStatus === 'inProgress'||goalStatus === 'completed'" id="goalBody" class="flexwrap" style="width: 100%" v-tooltip="completionMessage">
    <div v-for="(element, index) in sessionsDisplay" :key="index">
      <div
          class="day flexwrap centercenter alignText" :class="element.day !== null?'mediumShadow':''" :style="element.day !== null? 'background-color: var(--goalBackgroundColor);':'background-color: hsla(220, 60%,70%,0.09);'">
        <i class="fas fa-check-circle" style="z-index: 3; position:absolute; top: 0.2vw; right: 0; font-size: 0.9em" v-if="element.day !== null"></i>
        {{ week[element.day] }}
        <span style="color: var(--navBackgroundColor);" v-if="element.day === null">{{index+1}}</span>
      </div>
    </div>
  </div>

  <standard-button v-else-if="goalStatus === 'unset'"
                   :color-class="'olive'"
                   @click="$router.push({name: 'goal'})">
    Définir un objectif
  </standard-button>

</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "goal",
  components: {StandardButton: () => import(/* webpackPrefetch: true */ '@/components/standardButton.vue')},
  created() {

  },

  computed: {
    ...mapGetters('global', [
        'isMobile',
      'profile'
    ]),

    // On reformate les infos du profil pour pouvoir les traiter plus facilement
    weeklyGoal: function() {
      this.goals.forEach((element) => {
        if(element.day.name === 'sunday') {
          element.day.isOn = this.profile.datas.studying_sunday
        }

        else if(element.day.name === 'monday') {
          element.day.isOn = this.profile.datas.studying_monday
        }

        else if(element.day.name === 'tuesday') {
          element.day.isOn = this.profile.datas.studying_tuesday
        }

        else if(element.day.name === 'wednesday') {
          element.day.isOn = this.profile.datas.studying_wednesday
        }

        else if(element.day.name === 'thursday') {
          element.day.isOn = this.profile.datas.studying_thursday
        }

        else if(element.day.name === 'friday') {
          element.day.isOn = this.profile.datas.studying_friday
        }

        else if(element.day.name === 'saturday') {
          element.day.isOn = this.profile.datas.studying_saturday
        }
      })

      return this.goals
    },

    // On compte le nombre de jours en objectif
    sessionsGoal: function() {
      let nb = 0;
      this.weeklyGoal.forEach((element) => {
        if(element.day.isOn) {
          nb++
        }
      })

      return nb;
    },
    // On crée un tableau qui reflètera le degrès de completion de ses objectifs
    sessionsDisplay: function() {
      let currentWeek = [];

      // On crée un tableau contenant les jours de la semaine validés.
      let lastDate = ""
      this.profile.datas.week_sessions.forEach((element) => {
        if(element.date !== lastDate) {
          lastDate = element.date;
          let day = new Date(element.date).getDay()
          currentWeek.push({
            'day': day
          })
        }
      })

      const restant = this.sessionsGoal - currentWeek.length

      // Si le tableau est plus long que le nombre de sessions objectifs, on ne garde que les premières sessions
      if(currentWeek.length > this.sessionsGoal) {
        currentWeek.splice(this.sessionsGoal)
      }

      // Si le tableau est moins long que le nombre de sessions objectifs, on ajoute autant de cases vides que de sessions manquantes
      else if(currentWeek.length <this.sessionsGoal) {
        for(let i=0; i<restant; i++) {
          currentWeek.push({
            'day': null
          })
        }
      }

      return currentWeek
    },

    remainingDays: function() {
      let nb = 0;
      this.sessionsDisplay.forEach((element) => {
        if(element.day === null) {
          nb++
        }
      })

      return nb
    },

    completionMessage: function() {
      if(this.remainingDays === 1) {
        return this.remainingDays + ' jour restant pour valider la semaine'
      }
      else if(this.remainingDays > 1) {
        return this.remainingDays + ' jours restants pour valider la semaine'
      }
      return 'Semaine compétée ! :)'
    },

    goalStatus: function() {
      if(this.sessionsGoal === 0) {
        return 'unset'
      }
      else if(this.remainingDays === 0) {
        return 'completed'
      }
      return 'inProgress'
    }

  },

  data() {
    return {
      weeklySessionNb: 0,
      goals: [
        {
          day: {
            name: 'monday',
            isOn: false
          }
        },
        {
          day: {
            name: 'tuesday',
            isOn: false
          }
        },
        {
          day: {
            name: 'wednesday',
            isOn: false
          }
        },
        {
          day: {
            name: 'thursday',
            isOn: false
          }
        },
        {
          day: {
            name: 'friday',
            isOn: false
          }
        },
        {
          day: {
            name: 'saturday',
            isOn: false
          }
        },
        {
          day: {
            name: 'sunday',
            isOn: false
          },
        },
      ],

      week: {
        0: 'Dim',
        1: 'Lun',
        2: 'Mar',
        3: 'Mer',
        4: 'Jeu',
        5: 'Ven',
        6: 'Sam'
      }
    }
  }
}
</script>

<style scoped>
#goalBody{
  width:100%;
}

.day {
  position: relative;
  display: flex;
  height: 2.5vw;
  width: 2.5vw;
  border-radius: 2.5vw;
  font-weight: bold;
  font-size: 1em;
  margin-right: 0.5vw;
  margin-bottom: 0.5vw;
}


@media screen and (max-device-width: 767px) {
  .day {
    height: 10vw;
    width: 10vw;
    border-radius: 10vw;
    margin: 2vw 2vw 2vw 0;
  }
}
</style>